export const SEARCH_INDEX_NAME_BASE = 'petitions_';
export const SEARCH_PRESET_BASE = 'petitions_initial_';

export const SEARCH_VECTOR_INDEX_NAME_EN = 'petitions_vectors_en';
export const SEARCH_VECTOR_PRESET_EN = 'petitions_vectors_initial_en';
export const SEARCH_VECTOR_COLLECTION_LANGUAGE = 'en';
// Must match a variation name in packages/experiments/src/configs/configs/search_vector_collection.ts
export const SEARCH_VECTOR_COLLECTION_VARIATION = 'vector_collection';

export const SEARCH_SORT_BY_MOST_SIGNATURES = '/sort/total_signature_count:desc';
export const SEARCH_SORT_BY_LEAST_SIGNATURES = '/sort/total_signature_count:asc';
export const SEARCH_SORT_BY_NEWEST = '/sort/created_at:desc';

export const SEARCH_TOPIC_FILTER = 'tags';
export const SEARCH_VICTORY_FILTER = 'status';
export const SEARCH_LOCATION_CITY_FILTER = 'location.city_state';
export const SEARCH_LOCATION_COUNTRY_CODE_FILTER = 'location.country_code';
export const SEARCH_LOCATION_FILTER_MAX_ITEMS = 4;
export const SEARCH_TRENDING_FILTER = 'weekly_signature_count';
export const SEARCH_TRENDING_FILTER_VALUE = 10;
export const TYPESENSE_LOCATION_FILTER = 'city';
export const TYPESENSE_LOCATION_COLLECTION = 'locations';

export const SEARCH_CACHE_SECONDS = 2 * 60;

export const SEARCH_FACET_BY = `${SEARCH_TOPIC_FILTER},${SEARCH_VICTORY_FILTER},${SEARCH_LOCATION_CITY_FILTER},${SEARCH_LOCATION_COUNTRY_CODE_FILTER}`;
